import script from "./ConfirmAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmAddress.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmAddress.vue?vue&type=style&index=0&id=1e2f5f48&lang=css"

const __exports__ = script;

export default __exports__